export const container = `
  relative aspect-square rounded-full flex items-center justify-center overflow-hidden
`;

export const hole = `
  bg-ll-surface rounded-full w-[70%] h-[70%]
  flex items-center justify-center absolute
`;

export const iconContainer = `
  flex items-center justify-center
  w-full h-full

  [&>svg]:w-1/2
  [&>svg]:w-1/2
  [&>svg>path]:fill-ll-primary
`;
